import React from 'react';

const EmptyTableRow = ({ index, columnCount = 9 }) => {
  const renderEmptyCells = () => {
    const cells = [];
    const cellClasses = [
      "px-3 py-2.5",
      "px-3 py-2.5 text-sm",
      "px-3 md:px-6 py-3 md:py-4",
      "hidden lg:table-cell px-3 py-2.5 text-sm",
      "hidden md:table-cell px-3 py-2.5 text-sm",
      "px-3 py-2.5 text-sm",
      "hidden xl:table-cell px-3 py-2.5 text-sm",
      "hidden lg:table-cell px-3 py-2.5 text-sm",
      "px-3 py-2.5"
    ];

    for (let i = 0; i < columnCount; i++) {
      cells.push(
        <td key={i} className={`${cellClasses[i] || 'px-3 py-2.5'} text-gray-700`}>
          -
        </td>
      );
    }
    return cells;
  };

  return (
    <tr 
      key={`empty-${index}`} 
      className="bg-gray-900/30 hover:bg-gray-800/50" 
      style={{ height: '57px' }}
    >
      {renderEmptyCells()}
    </tr>
  );
};

export default EmptyTableRow;
